import { HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { FormLanguagesService } from '@app/form-languages';
import { ADD_FORM_LOCALES } from '../http-context';

export const formLocalesInterceptor: HttpInterceptorFn = (request, next) => {
    if (!request.context.get(ADD_FORM_LOCALES)) {
        return next(request);
    }
    const formLanguagesService = inject(FormLanguagesService);
    const params: HttpParams = new HttpParams().append('locale', formLanguagesService.current$.value);
    return next(request.clone({ params }));
};
